<template>
  <div>
    <div>

      <div class="layout-breadcrumb">
        <Breadcrumb>
          <Breadcrumb-item href="#" >
            <span style="color:#fff;">基础信息</span>
          </Breadcrumb-item>
          <Breadcrumb-item href="#">
          <span style="color:#fff;">生产基础数据维护</span>
          </Breadcrumb-item>
          <Breadcrumb-item href="#">
          <span style="color:#fff;">缺陷代码维护</span>
          </Breadcrumb-item>
        </Breadcrumb>
      </div>
      <div class="layout-content">
        <div class="layout-content-main">
            <Form  :model="formBug"  :label-width="95" >
                <div class="formLine" >
                        <FormItem label="缺陷代码" class="mRight" >
                            <Input v-model="formBug.bugCode" placeholder="缺陷代码"></Input>
                        </FormItem>
                        <FormItem label="缺陷名称" class="mRight" >
                            <Input v-model="formBug.bugName" placeholder="缺陷名称" ></Input>
                        </FormItem>
                        <FormItem label="缺陷大类代码" class="mRight">
                            <Select v-model="formBug.bigBug" placeholder="请选择缺陷大类代码查询" style="width:180px;" @on-change="this.searchCode">
                                <Option :value="value.code" :key="value.code" v-for ="value in bigcode">{{value.code}}</Option>
                            </Select>
                        </FormItem>
                        <FormItem label="缺陷大类名称">
                            <Select v-model="formBug.bigName" placeholder="缺陷大类名称" style="width:180px;" @on-change="this.searchName">
                                <Option :value="value.value" :key="value.value" v-for ="value in bigcode">{{value.value}}</Option>
                            </Select>
                        </FormItem>
                </div>
            </Form>
          <div  style="margin-bottom:20px;text-align:center;">
            <Button type="ghost" class="mRight mRight" @click="this.getResearch">查询</Button>
            <Button type="primary" class="mRight" @click="this.addBug">新增</Button> 
            <Button type="primary" class="mRight" @click="this.editMaintain">修改</Button> 
            <Button type="primary"  @click="this.del">删除</Button>
          </div>
          <div class="clearfix"></div>
          <div class="table-wrapper">
            <!-- <Table  border :columns="columns4" :data="nodes"></Table> -->
            <Table style="min-width: 700px" 
                border :columns="columns" 
                :data="pageData.data" 
                @on-selection-change="getSelected"
            
            ></Table >
            <div style="margin: 10px;overflow: hidden">
                <div style="float: right;">
                    <!-- <Page :total="this.total" :current="1" @on-change="changePage"></Page> -->
                     <Page :total="pageData.page.totalCount" @on-change="onChange"  show-sizer show-elevator show-total  @on-page-size-change="sizeChange"></Page>
                </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <!-----弹层------>
    <Modal
        v-model="addModal"
        :mask-closable="false"
    >
      <p slot="header" style="text-align:center">
        <Icon type="information-circled"></Icon>
        <span>{{modelName}}</span>
      </p> 
      <Form :model="addMaintain" :label-width="100" :rules="ruleValidate">
        <!-- <FormItem label="缺陷代码" >
            <Input v-model="addMaintain.code"></Input>
        </FormItem> -->
        <FormItem label="缺陷名称" prop="name">
            <Input v-model="addMaintain.name"></Input>
        </FormItem>
        <FormItem label="缺陷大类代码" prop="select">
            <Select v-model="addMaintain.select" @on-change="this.changeBig" :label-in-value="true">
                <Option :value="value.value"  :label="value.code" :key="value.value" v-for ="value in bigcode"><span>{{value.code}}</span><em class="fr">{{value.value}}</em></Option>
            </Select>
        </FormItem>
        <FormItem label="缺陷大类名称" prop="bigName">
            <Input v-model="addMaintain.bigName" disabled></Input>
        </FormItem>
        <FormItem label="是否使用" prop="ifuse">
             <RadioGroup v-model="addMaintain.ifuse">
                <Radio label="0" :class="[addMaintain.ifuse == '0' ? 'ivu-radio-checked' : '']">否</Radio>
                <Radio label="1" :class="[addMaintain.ifuse == '1' ? 'ivu-radio-checked' : '']">是</Radio>
            </RadioGroup>
        </FormItem>
        <!-- <FormItem label="更新人">
            <Input v-model="maintain.user"></Input>
        </FormItem> -->
      </Form>
      <div slot="footer">
         <Button type="primary" @click="addData('addMaintain')" long >确定</Button>
        </div>
    </Modal>
    <!---修改-->
    <Modal
        v-model="editModal"
        :mask-closable="false"
    >
      <p slot="header" style="text-align:center">
        <Icon type="information-circled"></Icon>
        <span>{{modelName}}</span>
      </p> 
      <Form :model="maintain" :label-width="100" :rules="ruleValidate2">
        <!-- <FormItem label="缺陷代码" >
            <Input v-model="maintain.code"></Input>
        </FormItem> -->
        <FormItem label="缺陷名称" prop="name">
            <Input v-model="maintain.name"></Input>
        </FormItem>
        <FormItem label="缺陷大类代码" prop="select" >
            <Select v-model="maintain.select" :label-in-value="true" @on-change="this.changeBig">
                <Option :value="value.value" :label="value.code" :key="value.value" v-for ="value in bigcode"><span >{{value.code}}</span><em class="fr">{{value.value}}</em></Option>
            </Select>
        </FormItem>
        <FormItem label="缺陷大类名称" prop="bigName">
            <Input v-model="maintain.bigName" disabled></Input>
        </FormItem>
        <FormItem label="是否使用" >
             <RadioGroup v-model="maintain.use" prop="ifuse">
                <Radio label="0" :class="[maintain.use == '0' ? 'ivu-radio-checked' : '']">否</Radio>
                <Radio label="1" :class="[maintain.use == '1' ? 'ivu-radio-checked' : '']">是</Radio>
            </RadioGroup>
        </FormItem>
        <!-- <FormItem label="更新人">
            <Input v-model="maintain.user"></Input>
        </FormItem> -->
      </Form>
      <div slot="footer">
         <Button type="primary" @click="submitData('maintain')" long >确定</Button>
        </div>
    </Modal>
    
  </div>
</template>
<style scoped lang="scss">
    .fr{
        float:right;
    }
    em{
        font-style: normal;
    }
    .formLine{
    display: flex;
  }
  .mRight{
    margin-right:10px;
  }
  .mLeft{
    margin-left:10px;
  }
</style>
<script>
  import api from '../../api/apinew'
  import axios from 'axios'
  import Qs from 'qs'

  export default{
    data(){
      return {
        modelName:'',
        maintain:{
            code:'',
            name:'',
            select:'',
            bigName:'',
            use:'',
            user:''
        },
        addMaintain:{
            code:'',
            name:'',
            select:'',
            bigName:'',
            ifuse:''
        },
        formBug:{
            bugCode:'',
            bugName:'',
            bigBug:'',
            bigName:''
        },
        addModal:false,
        editModal:false,
        useBoolean:true,
        columns: [
            {
                type: 'selection',
                width: 60,
                align: 'center'
            },
            {   
                title: '缺陷代码',
                key:'processBugId',
                align: 'center'
            },
            {
                title: '缺陷名称',
                key: 'processBugName',
                align: 'center'
            },
          
            {
                title: '缺陷大类代码',
                key: 'bugBigId',
                align: 'center'
            },
            {
                title: '缺陷大类名称',
                key: 'bugBigName',
                align: 'center'
            },
            {
                title: '是否使用',
                key: 'ifUser',
                align: 'center',
                render: (h, params) => {
                    const row = params.row;
                    const text = row.ifUser == 0 ? '×' : '√';
                    return h('span', text);
                }
            },
            {
                title: '更新人',
                key: 'modiPerson',
                align: 'center'
            },
            {
                title: '更新日期',
                key: 'modiDate',
                align: 'center'
            },
           
        ],
        pageData:{  
           data:[],  
           page:{  
              //分页数  
               // arrPageSize:[10,20,30,40],  
               //分页大小  
               pagesize:10,  
               //总分页数  
               pageCount:1,  
               //当前页面  
               pageCurrent:1,  
               //总数  
               totalCount:0  
           }  
        },
        selectedData:[],
        bigcode:[],
        type:'BugBig',
        ruleValidate:{
            name:[
                {required:true,message:'站点名称不能为空！',trigger:'blur'}
            ],
            select:[
                {required:true,message:'站点地址不能为空！',trigger:'blur'}
            ],
            bigName:[
                {required:true,message:'站点联系人不能为空！',trigger:'blur'}
            ],
            ifuse:[
               {required:true,message:'选择',trigger:'blur'} 
            ]
            
        },
        ruleValidate2:{
            name:[
                {required:true,message:'站点名称不能为空！',trigger:'blur'}
            ],
            select:[
                {required:true,message:'站点地址不能为空！',trigger:'blur'}
            ],
            bigName:[
                {required:true,message:'站点联系人不能为空！',trigger:'blur'}
            ],
            ifuse:[
               {required:true,message:'选择',trigger:'blur'} 
            ]
            
        },

      }
    },
    mounted:function(){  
     this.getList(this.pageData.page.pageCurrent,this.pageData.page.pagesize);//获取列表
     this.codeType(this.type);
      
       
    },
    methods: {
        //获取缺陷列表数据
        getList:function(pageCurrent,pagesize){
            api.bug.getList({
               'page': pageCurrent,
               'limit':pagesize
            },response =>{
                if(response.msg == 'success'){
                    console.log(response.page.list)
                    this.pageData.data = response.page.list;
                    this.pageData.page.totalCount = response.page.totalCount;
                    
                }else{
                    this.$Message.error(response.msg);
                }
            });
        },
        //搜索
         getResearch:function(){
               api.bug.getList({
                    'page':this.pageData.page.pageCurrent,
                    'limit':this.pageData.page.pagesize,
                    'processBugId':this.formBug.bugCode,
                    'processBugName':this.formBug.bugName,
                    'bugBigId':this.formBug.bigcode,
                    'bugBigName':this.formBug.bigName
                }, resp => {
                    if(resp.code == 0){
                        this.pageData.data = resp.page.list;
                    // 获取分页总条数
                    this.pageData.page.totalCount = resp.page.totalCount;
                    // this.formBug.bugCode = '';
                    // this.formBug.bugName = '';
                    // this.formBug.bigcode = '';
                    // this.formBug.bigName = '';
                    }
                }, error => {
                  this.$Message.error('请求失败');
                })
            
        },
        searchCode:function(value){
            this.formBug.bigcode = value;
        },
        searchName:function(value){
            this.formBug.bigName = value;
        },
        //选中
         getSelected:function(ele){
           this.selectedData = ele;
           console.log(ele)
        },
        // 分页 -- 页数改变
        onChange:function(curpage){  
            // alert("当前页面页码是：" + curpage);
            this.pageData.page.pageCurrent = curpage;
            this.getList(this.pageData.page.pageCurrent,this.pageData.page.pagesize);//获取列表
        },
        // 分页 -- pageSize 改变
        sizeChange:function(size){
         // alert("当前页面size是：" + size);
          this.pageData.page.pagesize = size;
          this.getList(this.pageData.page.pageCurrent,this.pageData.page.pagesize);//获取列表
        },
        //弹层
        //新增
        addBug:function(){
            this.modelName = '新增';
            this.addModal = true ;
            this.maintain = {};
        },
        addData:function(name){
            api.bug.addBug({
                processBugId: this.addMaintain.code,
                processBugName: this.addMaintain.name,
                bugBigId:this.addMaintain.select,
                bugBigName:this.addMaintain.bigName,
                ifUser:this.addMaintain.ifuse
            },res=>{
                if(res.msg =='success'){
                     this.$Message.success('新增成功!'); 
                     this.addModal = false; 
                     this.getList(this.pageData.page.pageCurrent,this.pageData.page.pagesize);//获取列表
                 }else{
                      this.$Message.error('新增失败!'); 
                }
            });
        },
        //修改
        editMaintain:function(){
            if(this.selectedData.length == 0){
               this.$Message.error('请选择一条记录!');
               return;
           }else if(this.selectedData.length >1){
                this.$Message.error('只能选择一条数据进行修改');
               return;
           }else{
               this.editModal = true ;
               this.modelName = '修改';
               this.maintain = {
                   // code :  this.selectedData[0].processBugId,
                    name:  this.selectedData[0].processBugName,
                    select :  this.selectedData[0].bugBigId,
                  bigName : this.selectedData[0].bugBigName,
                  use:this.selectedData[0].ifUser
               };
           }
           
        },
        submitData:function(name){
                 api.bug.editBug({
                    id:this.selectedData[0].id,
                   processBugId: this.maintain.code,
                   processBugName: this.maintain.name,
                   bugBigId:this.maintain.select,
                   bugBigName:this.maintain.bigName,
                   ifUser:this.maintain.use
                 },res=>{
                     if(res.code == 0){
                         this.$Message.success('修改成功');
                         this.editModal = false; 
                         this.getList(this.pageData.page.pageCurrent,this.pageData.page.pagesize);//获取列表
                     }else{
                         this.$Message.error(response.msg); 
                     }
                 }); 
            
        },
    //获取某一类
        // getBigname:function(param){
        //    api.bug.bugDesc(param,res=>{
        //        if(res.code == 0){
        //            this.bigcode = res.jcTBugDesc;
        //            console.log(this.bigcode)
        //        }
        //    });
        // },
    //选择大类代码
    codeType:function(param){
        api.bug.bugType(param,res=>{
            if(res.code == 0){
              this.bigcode =  res.typeList; 
            }
        });
    },
        changeBig:function(ele){
            if(this.modelName == '修改'){
                this.maintain.bigName = ele.value;
                this.maintain.select = ele.code;
            }else if(this.modelName == '新增'){
                console.log('sss')
                this.addMaintain.bigName = ele.value;
                this.maintain.select = ele.code;
            }
            
        },
        delBug:function(ids){
        api.bug.delBug(ids,response=>{
              if(response.msg == 'success'){
                this.$Message.success('删除成功!'); 
                this.getList(this.pageData.page.pageCurrent,this.pageData.page.pagesize);//获取列表
              }else{
                this.$Message.error(response.msg); 
              }
            })
    },
    del:function(){
        var ids =[];
            if(this.selectedData.length == 0 || this.selectedData.length == undefined){
                this.$Message.error('请至少选择一条记录!');
                return;
            }else{
                for(var i=0 ;i < this.selectedData.length; i++){
                  ids.push(this.selectedData[i].id);
                }
                this.delBug(ids);
            } 
    }
    },
    
      
    }
</script>



// WEBPACK FOOTER //
// customer.vue?13d0f564